module.exports = __webpack_public_path__ + "img/XL_LOGO_INOE_MOBI_BULLE.a1986b00.svg";